import type { FC } from "react";
import { Fragment } from "react";
import { loadMFE } from "../../mfe/mfeLoaders";
import { SidebarSubMenuItem } from "./SidebarSubMenuItem";
import { SubMenuSectionTitle } from "./SubMenuSectionTitle";
import { type MFE, type SubNavigationConfig } from "./type";

type SubMenuContentProps = {
  subNavigationConfig: readonly SubNavigationConfig[];
  parentMfe: MFE;
  id: string;
};
export const SubMenuContent: FC<SubMenuContentProps> = ({
  subNavigationConfig,
  parentMfe,
  id,
}) => (
  <>
    {subNavigationConfig.map((section) => (
      <Fragment key={section.sectionTitle}>
        {subNavigationConfig.length > 1 && (
          <SubMenuSectionTitle
            key={section.sectionTitle}
            text={section.sectionTitle}
          />
        )}
        {section.subRoutes.map((subRoute) => {
          // Don't render menu items for elements without text to allow
          // for "hidden" subroutes
          if (!subRoute.label) {
            return <></>;
          }
          return (
            <SidebarSubMenuItem
              id={id}
              key={`${subRoute.href}-${subRoute.path}`}
              onHover={() =>
                subRoute.mfe
                  ? loadMFE(subRoute.mfe.name, subRoute.mfe.entry)
                  : loadMFE(parentMfe.name, parentMfe.entry)
              }
              subRoutes={section.subRoutes}
              thisSubRoute={subRoute}
            />
          );
        })}
      </Fragment>
    ))}
  </>
);
